var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _vm.show ? _c("main", {
    staticClass: "form-edit-page"
  }, [_c("section", [_c("div", {
    staticClass: "slide",
    style: _vm.show ? "transform: translateX(-280px); opacity: 1; visibility: visible;" : "transform: translateX(0px); opacity: 0; visibility: hidden;"
  }, [_c("h2", {
    staticClass: "form-head"
  }, [_c("svg", {
    staticClass: "slide-container-head-icon",
    attrs: {
      width: "30",
      height: "30",
      "aria-hidden": "true"
    },
    on: {
      click: _vm.handleBack
    }
  }, [_c("use", {
    attrs: {
      "xlink:href": "#iconfanhuibeifen"
    }
  })]), _c("span", [_vm._v(" " + _vm._s(_vm.title) + " ")])]), _c("div", {
    staticClass: "body"
  }, [_vm._t("default")], 2)])])]) : _vm._e();
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };